import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Exchange_Programs from "./exchange_programs/Exchange_Programs";
import Rank from "./rank/Rank";
import Specialization from "./specialization/Specialization";
import Global_education from "./global-education/Global_education";
import Online_degree from "./online-degree/Online_degree";
import Learn_ai from "./learn-ai/Learn_ai";
import Who_we_are from "./who-we-are/Who_we_are";
import Dpu_alumni from "./dpu-alumni/Dpu_alumni";
import Explore_Programs from "./explore_programs/Explore_Programs";
import Kickstart_Your_Career from "./kickstart_your_career/Kickstart_Your_Career";
import FAQ from "../faq/FAQ";
import Knowledge_Blog from "./knowledge_blog/Knowledge_Blog";
import Student_Feedback from "./student_feedback/Student_Feedback";
import Enquiry_Form_Modal from "../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal";
import Certificate from "./certificate/Certificate";
import Program_takeway from "./program-takeway/Program_takeway";
import Banner_2 from "./banner_2/Banner_2";

function Home({ exploreProgramRef }) {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  const exploreProgramsRef = useRef(null);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowModal(true);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, []);

  // Expose the ref to parent
  useEffect(() => {
    if (exploreProgramRef) {
      exploreProgramRef.current = exploreProgramsRef.current;
    }
  }, [exploreProgramRef]);

  return (
    <>
      {/* <Banner /> */}
      <Banner_2 />
      <Rank />
      <Explore_Programs />
      <Specialization />
      <Global_education />
      <Online_degree />
      <Learn_ai />
      <Who_we_are />
      <Program_takeway />
      <Exchange_Programs />
      <Certificate />
      <Dpu_alumni />
      <Student_Feedback />
      <Knowledge_Blog />
      {/* <FAQ /> */}
      <Kickstart_Your_Career />

      <Enquiry_Form_Modal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
}

export default Home;
